const Chili = ({ active }) => (
    <svg
        width="14"
        height="20"
        viewBox="0 0 14 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden="true"
    >
        <path
            d="M3.2 3.2 C 4.6 1.5, 6.9 1, 8.2 2.4 c 0.6 -0.8 1.9 -1.4 2.6 -0.6 c 0.7 0.8 -0.1 2.1 -0.8 2.5 c 1.6 1.4 2.4 3.7 1.9 6 c -0.8 4.1 -4.2 8.2 -7.7 8.2 c -3.1 0 -4.8 -3.1 -3.4 -6.1 C 1.9 9.1 4.2 6 3.2 3.2 z"
            fill={active ? "var(--kp-red)" : "transparent"}
            stroke={active ? "var(--kp-red-deep)" : "rgba(38,28,21,0.28)"}
            strokeWidth="1"
        />
        {active && (
            <path
                d="M9.2 2.5 c 0.4 -0.6 1.2 -0.9 1.6 -0.3"
                stroke="#3a6a2a"
                strokeWidth="1.2"
                strokeLinecap="round"
                fill="none"
            />
        )}
    </svg>
);

export const ChiliHeat = ({ level = 3, label }) => {
    return (
        <div
            className="flex items-center gap-2"
            data-testid={`heat-level-${level}`}
        >
            {label && (
                <span className="text-[10px] tracking-mono-wide text-[color:var(--kp-ink)]/60">
                    {label}
                </span>
            )}
            <div className="flex items-center gap-[3px]">
                {[1, 2, 3, 4, 5].map((i) => (
                    <Chili key={i} active={i <= level} />
                ))}
            </div>
        </div>
    );
};
